var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path3, _circle10, _circle11, _path4, _path5, _mask, _path6, _circle12, _path7, _path8, _path9, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _ellipse, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlanetWithFlag = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 79,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 28.5311C21.6336 28.5311 22.9998 27.2127 22.9998 24.0311C22.9998 27.2127 24.3565 28.5311 27.4998 28.5311C24.3565 28.5311 22.9998 29.8878 22.9998 33.0311C22.9998 29.8878 21.6336 28.5311 18.4998 28.5311Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 60.5311C129.634 60.5311 131 59.2127 131 56.0311C131 59.2127 132.356 60.5311 135.5 60.5311C132.356 60.5311 131 61.8878 131 65.0311C131 61.8878 129.634 60.5311 126.5 60.5311Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.472,
    cy: 7.61665,
    r: 1.58552,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.085,
    cy: 25.6167,
    r: 1.58552,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0853,
    cy: 10.6167,
    r: 1.58552,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.744,
    cy: 29.6037,
    r: 0.937778,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.164,
    cy: 33.7658,
    r: 0.937778,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25589,
    cy: 18.2091,
    r: 0.937778,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2559,
    cy: 18.2091,
    r: 0.937778,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9961,
    cy: 54.1398,
    r: 0.937778,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.55598,
    cy: 64.6967,
    r: 1.58552,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1709 19.7373L72.7266 9.52843C72.6544 9.22663 72.8242 8.91954 73.1182 8.82026L74.4293 7.47091C75.5235 6.34487 77.0907 5.81102 78.6447 6.03503V6.03503C79.8707 6.21175 81.118 5.91789 82.1361 5.21251L86.4958 2.19198C86.83 2.07911 87.1891 2.27761 87.2712 2.62075L89.5625 12.1907C89.6347 12.4925 89.4649 12.7996 89.1709 12.8989L84.7409 15.928C83.6656 16.6633 82.3579 16.9783 81.0658 16.8134V16.8134C79.4658 16.6092 77.8597 17.1421 76.6992 18.2623L75.1709 19.7373ZM75.1709 19.7373L78.9816 36.0236",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9998,
    cy: 64.5311,
    r: 1.5,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9998,
    cy: 54.5311,
    r: 1.5,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1075 60.3086C61.3684 66.7511 44.7923 67.9449 43.0837 62.975C42.1676 60.3105 45.7111 56.4153 52.0835 52.3821",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5638 36.7697C105.098 36.0222 110.31 36.9129 111.229 39.5838C112.937 44.5537 99.1314 53.8051 80.3923 60.2476L78.1795 61.0083",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-1_10939_50413",
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2878,
    cy: 36.3767,
    rx: 2.98904,
    ry: 1.32846,
    transform: "rotate(-14.0976 79.2878 36.3767)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.247 36.1358C80.1332 35.6825 80.2762 35.3428 80.3439 35.223C80.4047 35.1156 80.4349 35.1188 80.3335 35.1982C80.1351 35.3536 79.7183 35.5762 79.1242 35.7254L80.0985 39.6049C81.1055 39.352 82.0658 38.9221 82.7995 38.3477C83.1641 38.0622 83.5492 37.6811 83.8259 37.1917C84.1096 36.6899 84.3298 35.9705 84.1266 35.1615L80.247 36.1358ZM79.1242 35.7254C78.5301 35.8746 78.0577 35.8753 77.8093 35.8321C77.6824 35.8101 77.7076 35.7929 77.8119 35.8589C77.9282 35.9325 78.2147 36.1643 78.3285 36.6176L74.449 37.5919C74.6522 38.4009 75.1861 38.931 75.6732 39.2392C76.1483 39.5398 76.6677 39.6937 77.124 39.773C78.042 39.9326 79.0915 39.8578 80.0985 39.6049L79.1242 35.7254ZM78.3285 36.6176C78.4424 37.0709 78.2994 37.4106 78.2316 37.5304C78.1709 37.6378 78.1406 37.6346 78.242 37.5551C78.4405 37.3997 78.8573 37.1772 79.4514 37.028L78.4771 33.1485C77.4701 33.4014 76.5097 33.8313 75.7761 34.4057C75.4114 34.6912 75.0263 35.0722 74.7496 35.5616C74.4659 36.0634 74.2458 36.7828 74.449 37.5919L78.3285 36.6176ZM79.4514 37.028C80.0455 36.8788 80.5179 36.878 80.7662 36.9212C80.8931 36.9433 80.868 36.9604 80.7637 36.8944C80.6474 36.8209 80.3609 36.589 80.247 36.1358L84.1266 35.1615C83.9234 34.3524 83.3895 33.8224 82.9024 33.5142C82.4273 33.2136 81.9078 33.0597 81.4515 32.9804C80.5335 32.8207 79.484 32.8956 78.4771 33.1485L79.4514 37.028Z",
    fill: "currentColor",
    mask: "url(#path-17-inside-1_10939_50413)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.9998,
    cy: 51.5311,
    r: 25.5,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6774 75.3161C67.9356 71.182 71.4962 68.04 75.6303 68.2982C79.7644 68.5564 82.9064 72.1171 82.6482 76.2512",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 45.3265C97.9309 46.0072 94.0668 43.2468 93.3861 39.161C93.0289 37.0175 93.6189 34.935 94.8505 33.3412",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4806 29.2714C68.4715 32.1371 68.5731 36.8847 65.7074 39.8756C62.8418 42.8665 58.0942 42.968 55.1033 40.1024",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 79,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 79",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 28.5311C21.6336 28.5311 22.9998 27.2127 22.9998 24.0311C22.9998 27.2127 24.3565 28.5311 27.4998 28.5311C24.3565 28.5311 22.9998 29.8878 22.9998 33.0311C22.9998 29.8878 21.6336 28.5311 18.4998 28.5311Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 60.5311C129.634 60.5311 131 59.2127 131 56.0311C131 59.2127 132.356 60.5311 135.5 60.5311C132.356 60.5311 131 61.8878 131 65.0311C131 61.8878 129.634 60.5311 126.5 60.5311Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.472,
    cy: 7.61665,
    r: 1.58552,
    fill: "currentColor"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.085,
    cy: 25.6167,
    r: 1.58552,
    fill: "currentColor"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0853,
    cy: 10.6167,
    r: 1.58552,
    fill: "currentColor"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.744,
    cy: 29.6037,
    r: 0.937778,
    fill: "currentColor"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.164,
    cy: 33.7658,
    r: 0.937778,
    fill: "currentColor"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25589,
    cy: 18.2091,
    r: 0.937778,
    fill: "currentColor"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2559,
    cy: 18.2091,
    r: 0.937778,
    fill: "currentColor"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9961,
    cy: 54.1398,
    r: 0.937778,
    fill: "currentColor"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.55598,
    cy: 64.6967,
    r: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.1709 19.7373L72.7266 9.52843C72.6544 9.22663 72.8242 8.91954 73.1182 8.82026L74.4293 7.47091C75.5235 6.34487 77.0907 5.81102 78.6447 6.03503V6.03503C79.8707 6.21175 81.118 5.91789 82.1361 5.21251L86.4958 2.19198C86.83 2.07911 87.1891 2.27761 87.2712 2.62075L89.5625 12.1907C89.6347 12.4925 89.4649 12.7996 89.1709 12.8989L84.7409 15.928C83.6656 16.6633 82.3579 16.9783 81.0658 16.8134V16.8134C79.4658 16.6092 77.8597 17.1421 76.6992 18.2623L75.1709 19.7373ZM75.1709 19.7373L78.9816 36.0236",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9998,
    cy: 64.5311,
    r: 1.5,
    fill: "currentColor"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9998,
    cy: 54.5311,
    r: 1.5,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.1075 60.3086C61.3684 66.7511 44.7923 67.9449 43.0837 62.975C42.1676 60.3105 45.7111 56.4153 52.0835 52.3821",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5638 36.7697C105.098 36.0222 110.31 36.9129 111.229 39.5838C112.937 44.5537 99.1314 53.8051 80.3923 60.2476L78.1795 61.0083",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-1_10939_50413",
    fill: fill
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2878,
    cy: 36.3767,
    rx: 2.98904,
    ry: 1.32846,
    transform: "rotate(-14.0976 79.2878 36.3767)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.247 36.1358C80.1332 35.6825 80.2762 35.3428 80.3439 35.223C80.4047 35.1156 80.4349 35.1188 80.3335 35.1982C80.1351 35.3536 79.7183 35.5762 79.1242 35.7254L80.0985 39.6049C81.1055 39.352 82.0658 38.9221 82.7995 38.3477C83.1641 38.0622 83.5492 37.6811 83.8259 37.1917C84.1096 36.6899 84.3298 35.9705 84.1266 35.1615L80.247 36.1358ZM79.1242 35.7254C78.5301 35.8746 78.0577 35.8753 77.8093 35.8321C77.6824 35.8101 77.7076 35.7929 77.8119 35.8589C77.9282 35.9325 78.2147 36.1643 78.3285 36.6176L74.449 37.5919C74.6522 38.4009 75.1861 38.931 75.6732 39.2392C76.1483 39.5398 76.6677 39.6937 77.124 39.773C78.042 39.9326 79.0915 39.8578 80.0985 39.6049L79.1242 35.7254ZM78.3285 36.6176C78.4424 37.0709 78.2994 37.4106 78.2316 37.5304C78.1709 37.6378 78.1406 37.6346 78.242 37.5551C78.4405 37.3997 78.8573 37.1772 79.4514 37.028L78.4771 33.1485C77.4701 33.4014 76.5097 33.8313 75.7761 34.4057C75.4114 34.6912 75.0263 35.0722 74.7496 35.5616C74.4659 36.0634 74.2458 36.7828 74.449 37.5919L78.3285 36.6176ZM79.4514 37.028C80.0455 36.8788 80.5179 36.878 80.7662 36.9212C80.8931 36.9433 80.868 36.9604 80.7637 36.8944C80.6474 36.8209 80.3609 36.589 80.247 36.1358L84.1266 35.1615C83.9234 34.3524 83.3895 33.8224 82.9024 33.5142C82.4273 33.2136 81.9078 33.0597 81.4515 32.9804C80.5335 32.8207 79.484 32.8956 78.4771 33.1485L79.4514 37.028Z",
    fill: "currentColor",
    mask: "url(#path-17-inside-1_10939_50413)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.9998,
    cy: 51.5311,
    r: 25.5,
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6774 75.3161C67.9356 71.182 71.4962 68.04 75.6303 68.2982C79.7644 68.5564 82.9064 72.1171 82.6482 76.2512",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.017 45.3265C97.9309 46.0072 94.0668 43.2468 93.3861 39.161C93.0289 37.0175 93.6189 34.935 94.8505 33.3412",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4806 29.2714C68.4715 32.1371 68.5731 36.8847 65.7074 39.8756C62.8418 42.8665 58.0942 42.968 55.1033 40.1024",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }));
});
export default SvgIconPlanetWithFlag;
export const raw = __webpack_public_path__ + "static/media/icon-planet-with-flag.82ff472f4dcbb76e85765e709a6367ef.svg";